import type { PropsWithChildren } from 'react';
import type { SlideImageLayoutProps } from './types';
import { PartialImageLayout } from './PartialImageLayout';
import { getSlideImageConfiguration } from './getSlideImageConfiguration';
import { SlidePadding } from './SlidePadding';

export const PartialImageLayoutDataHandler = ({
  image,
  staticContent,
  hasInteractiveContents,
  children,
}: PropsWithChildren<SlideImageLayoutProps>) => {
  const slideImageConfiguration = getSlideImageConfiguration({
    image,
    staticContent,
    hasInteractiveContents,
  });

  if (slideImageConfiguration.partialImageLayout) {
    return (
      <PartialImageLayout
        image={slideImageConfiguration.partialImageLayout.image}
        hasImageInset={slideImageConfiguration.partialImageLayout.hasImageInset}
        snapDirection={slideImageConfiguration.partialImageLayout.snapDirection}
        imagePosition={slideImageConfiguration.partialImageLayout.imagePosition}
        layoutSize={slideImageConfiguration.partialImageLayout.layoutSize}
      >
        {children}
      </PartialImageLayout>
    );
  }

  return <SlidePadding>{children}</SlidePadding>;
};
